export default __webpack_public_path__ + "static/media/sidebar1.d5cb53bd.jpg";